import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { useIdleTimer } from "react-idle-timer";

import { refreshSession } from "../services/authSession";

const IDLE_TIMEOUT_MS = 5 * 60 * 1000;
const SESSION_REFRESH_MS = 1 * 60 * 1000;

const SignedInSessionTimers = () => {
  const handleOnIdle = async () => {
    console.log("timeout");
  };

  const handleOnActive = (event) => {
    console.log("user is active", event);
    console.log("time remaining", getRemainingTime());
  };

  const handleOnAction = (event) => {
    // console.log("user did something", event);
  };

  const { getRemainingTime, isIdle } = useIdleTimer({
    timeout: IDLE_TIMEOUT_MS,
    onIdle: handleOnIdle,
    onActive: handleOnActive,
    onAction: handleOnAction,
    debounce: 250,
  });

  const isIdleRef = useRef(isIdle);
  isIdleRef.current = isIdle;

  useEffect(() => {
    let cancelled = false;
    let timeoutId;

    const scheduleRefresh = () => {
      timeoutId = window.setTimeout(async () => {
        if (cancelled) return;

        if (!isIdleRef.current()) {
          try {
            await refreshSession();
          } catch (error) {
            console.error("Session refresh failed:", error);
          }
        }

        if (!cancelled) scheduleRefresh();
      }, SESSION_REFRESH_MS);
    };

    scheduleRefresh();

    return () => {
      cancelled = true;
      window.clearTimeout(timeoutId);
    };
  }, []);

  return null;
};

/**
 * On sign-in, start a 25-minute timer. If the user is still active when it
 * fires, call GET /refresh to extend the session, then schedule the next tick.
 */
const SessionKeepAlive = () => {
  const isSignedIn = useSelector((state) => state.AuthenticationData.isSignedIn);

  if (!isSignedIn) return null;

  return <SignedInSessionTimers />;
};

export default SessionKeepAlive;
